import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select } from '../styled-components/';

const $ = window.$;

const Container = styled.div`
  display: flex;
  &.loading .select2-container {
    background-image: url('images/inputLoading.gif');
    background-position: center right 1rem;
    background-repeat: no-repeat;
    background-size: 1.25rem;
  }
  .select2-container .select2-selection--single .select2-selection__rendered {
    white-space: pre;
  }
`;

const LoadingSpinner = styled.img`
  display: ${props => (props.visible ? 'block' : 'none')};
  align-self: center;
  margin-left: 0.25rem;
  width: 1rem;
  height: 1rem;
`;

class AutoCompleteInput extends Component {
  componentDidMount() {
    this.updateAutoComplete();
    $(this.input).on('select2:select', this.onChange);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const key = nextProps.value.replace(/'/g, "\\'");
    if ($(this.input).find(`option[value='${key}']`).length) {
      $(this.input)
        .val(nextProps.value)
        .trigger('change');
    } else {
      // Create a DOM Option and pre-select by default
      const newOption = new Option(nextProps.value, nextProps.value, true, true);
      // Append it to the select
      $(this.input)
        .append(newOption)
        .trigger('change');
    }
  }

  componentDidUpdate() {
    this.updateAutoComplete();
  }

  componentWillUnmount() {
    $(this.input).select2('destroy');
    $(this.input).off('select2:select', this.onChange);
  }

  onChange = event => {
    const options = event.target.options;
    this.props.onChange(
      options.selectedIndex,
      this.props.name,
      options[options.selectedIndex].value,
      this.props.autofillGroup
    );
  };

  updateAutoComplete = () => {
    const data = this.props.data.map(d => ({ id: d, text: d, selected: d === this.props.value }));
    $(this.input).select2({
      createTag: params =>
        params.term
          ? {
            id: params.term,
            text: params.term,
            newTag: true
          }
          : null,
      data,
      tags: true
    });
  };

  render() {
    return (
      <Container>
        <Select ref={r => (this.input = r)} {...this.props} />
        <LoadingSpinner src="images/inputLoading.gif" visible={this.props.loading} />
      </Container>
    );
  }
}

AutoCompleteInput.defaultProps = {
  onChange: () => {},
  autofillGroup: '-1',
  loading: false,
  value: ''
};

AutoCompleteInput.propTypes = {
  name: PropTypes.string.isRequired,
  autofillGroup: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  value: PropTypes.string
};

export default AutoCompleteInput;



// WEBPACK FOOTER //
// ./app/components/AutoCompleteInput.js